/* ─────────────────────────────────────────
   portfolioData.js
   ✏️  Edit this file to update your portfolio content.
───────────────────────────────────────── */

// ── EDUCATION ────────────────────────────
export const education = {
  school:     'California State University, Fullerton',
  short:      'CSUF',
  degree:     'Bachelor of Science in Computer Science',
  graduation: 'Expected Graduation: May 2027',      
  highlights: [
    // Relevant coursework — shows employers you have the theory background
    {
      label: 'Relevant Coursework',
      items: [
        'Data Structures',
        'Algorithm Engineering',
        'Software Engineering',
        'File Structures and Databases',
        'Compilers',
        'Edge AI',
        'AI Principles',
        'Operating Systems',
        'Modern Software Development',
        'Object-Oriented Programming',
      ],
    },
    // Clubs / orgs — shows involvement beyond just classes
    {
      label: 'Involvement',
      items: [
        'Association for Computing Machinery (ACM)',  
        'Theta Tau ΘT - Engineering Fraternity',
      ],
    },
  ],
};

// ── ABOUT ────────────────────────────────
export const about = {
  bio: [
    "I'm a 4th year Computer Science student at Cal State Fullerton with a passion for building things. I grew up building legos and computers, but now I have transitioned to building cars and software. I primarily like making programs that make my life easier. I have a strong passion for cars and financial literacy and am actively trying to pursue my career in the Fintech or Automotive industry. I also have a strong interest in AI and its applications, and I'm excited to see how it will shape the future of technology.",
    "When I actually go outside and not stuck in front of my computer, I'm usually at a coffee shop or cafe trying new coffee, working on cars, snowboarding when its in season, or attending music festivals. As much as I love to code, I typically enjoy being out more then home <3.",
  ],
};

// ── SKILLS ───────────────────────────────
// To add/remove a skill, edit these arrays.
// Icons are pulled from https://skillicons.dev — free, no setup needed.
// Full icon list: https://skillicons.dev/icons?i=all
export const skills = {
  languages: [
    { name: 'Python',     icon: 'https://skillicons.dev/icons?i=python' },
    { name: 'C++',        icon: 'https://skillicons.dev/icons?i=cpp' },
    { name: 'SQL',        icon: 'https://skillicons.dev/icons?i=mysql' },
    { name: 'JavaScript', icon: 'https://skillicons.dev/icons?i=js' },
    { name: 'HTML',       icon: 'https://skillicons.dev/icons?i=html' },
    { name: 'CSS',        icon: 'https://skillicons.dev/icons?i=css' },
    { name: 'C#',         icon: 'https://skillicons.dev/icons?i=cs' },
  ],
  technologies: [
    { name: 'React.js',            icon: 'https://skillicons.dev/icons?i=react' },
    { name: 'Supabase',            icon: 'https://skillicons.dev/icons?i=supabase' },
    { name: 'Vite.js',             icon: 'https://skillicons.dev/icons?i=vite' },
    { name: 'Unity',               icon: 'https://skillicons.dev/icons?i=unity' },
    { name: 'Git',                 icon: 'https://skillicons.dev/icons?i=git' },
    { name: 'AWS',                 icon: 'https://skillicons.dev/icons?i=aws' },
    { name: 'Linux',               icon: 'https://skillicons.dev/icons?i=linux' },
    { name: 'Power BI',            icon: 'https://skillicons.dev/icons?i=powerbi' },
    { name: 'Postman',             icon: 'https://skillicons.dev/icons?i=postman' },
    { name: 'REST APIs',           icon: 'https://skillicons.dev/icons?i=fastapi' },
    { name: 'JIRA',                icon: 'https://raw.githubusercontent.com/marwin1991/profile-technology-icons/refs/heads/main/icons/jira.png' },
    { name: 'Oracle SQL Dev',      icon: 'https://raw.githubusercontent.com/marwin1991/profile-technology-icons/refs/heads/main/icons/oracle.png' },
    { name: 'Power Automate',      icon: 'https://skillicons.dev/icons?i=azure' },
    { name: 'Quantum Control',     icon: 'https://skillicons.dev/icons?i=docker' },
  ],
};

// ── WORK EXPERIENCE ──────────────────────
export const initialExperience = [
  {
    id: 1,
    date:    'August 2025 — May 2026',
    role:    'Junior Developer & Data Analyst',
    company: 'OMI Specialty Products · Fullerton, CA',
    desc:    'Developed Python and SQL-based automation pipelines and a Flask warehouse management application that streamlined legacy ERP workflows, eliminated 90% of redundant records, improved data retrieval efficiency by 60%, integrated cross-department systems through REST and GraphQL APIs, and reduced annual operational costs by $12K.',
  },
  {
    id: 2,
    date:    'January 2026 - May 2026',
    role:    'Career Development Mentee',
    company: 'J.P. Morgan · Irvine, CA',
    desc:    'J.P. Morgan Mentorship Program through Big Brothers Big Sisters of America',
  },
  {
    id: 3,
    date:    'June 2025 - August 2025',
    role:    'IT Development Intern',
    company: 'OMI Specialty Products · Fullerton, CA',
    desc:    'Developed scalable multi-threaded Python migration tools to automate the transfer of 5TB+ of data across 200K+ files and 100+ relational tables, successfully centralizing 70+ legacy ERP tables while maintaining 100% data integrity and enabling long-term historical analysis.',
  },
  {
    id: 4,
    date:    'June 2025 — August 2025',
    role:    'Software Engineer Intern',
    company: 'Divine Software Systems LLC · Fremont, CA',
    desc:    'Developed scalable backend and interactive frontend features using JavaScript and Python within an Agile development environment. Built modular API-based services, practiced test-driven development, and contributed peer-reviewed code to production systems used by internal teams.',
  },
  {
    id: 5,
    date:    'January 2023 — June 2023',
    role:    'Configuration Analyst Intern',
    company: 'Altierus Career College · Remote',
    desc:    'Translated business requirements into technical system configurations supporting large multi-institution deployments. Produced technical documentation and implementation specifications that improved onboarding efficiency and reduced user support issues.',
  },
];

// ── PROJECTS ─────────────────────────────
// To show a real screenshot, set `image: '/images/your-screenshot.png'`
// and place the file in the /public/images/ folder.
export const projects = [
  {
    id:    1,
    title: 'Espressowe',
    tag:   'Web App · TypeScript, React.js, Expo, Supabase, Plaid, JavaScript, CSS',
    desc:  'Developed a full-stack web application that integrates with Plaid API to allow users to connect their banking institutions and have real-time financial tracking, management, and insights. The app features a user-friendly interface built with React.js and Expo, and utilizes Supabase for secure data storage and authentication.',
    link:  'https://github.com/alyxce1015/esspressowe-cc-manager',
    image: '/cc-manager_photo.png',
  }, 
  {
    id:    2,
    title: 'Personal Portfolio Website',
    tag:   'Website · HTML, CSS, JavaScript, React.js',
    desc:  'Developed a personal portfolio website using React.js to showcase my projects, skills, and experience.',
    link:  'https://github.com/alyxce1015/personal_portfolio_website',
    image: '/coffee.png',
  },  
  {
    id:    3,
    title: 'Nu Deck',
    tag:   'Video Game · Unity, C#',
    desc:  'Developed a 2D Pokemon style game in Unity that features core mechanics from the original game.',
    link:  'https://github.com/Kentalope22/Nu-Deck',
    image: '/NuDeck_Web_image.png',
  },

  {
    id:    4,
    title: 'Ricewerkz Official Site',
    tag:   'Website · HTML, CSS, JavaScript, React.js, Vite, Supabase, Cloudinary',
    desc:  "Developed a website for a Content Creator group 'Ricewerkz' using React.js and Vite frameworks and utilizing database and media storage technologies such as Cloudinary and Supabase.",
    link:  'https://github.com/alyxce1015/RiceWerkz-Website',
    image: '/RW_project_cover.png',
  },
  {
    id:    5,
    title: 'Mock UN Database Admin',
    tag:   'Database Structure · MySql',
    desc:  'Built a database structure to imitate the United Nations database, which includes tables for countries, representatives, and resolutions.',
    link:  'https://github.com/alyxce1015/UN-database-admin-Project',
    image: '/EER diagram.png',
  },
  {
    id:    6,
    title: 'Nebuluv',
    tag:   'Web App · HTML, CSS, JavaScript',
    desc:  'FullyHacks 2025 Hackathon Project - Personality quiz that finds you your alien match based on your preferences.',
    link:  'https://github.com/k8iekitkat/nebuluv',
    image: '/nebuluv.PNG',
  },
];